module.exports = __webpack_public_path__ + "static/media/pic-das-steck-drin-2.4e9c0f86.png";